import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../../Particle";
import { AiOutlineDownload } from "react-icons/ai";
import Fade from "react-reveal/Fade";
import "../../style.css";

// Google Drive Resume Link Configuration
// File ID: 14wqI8NJmdzDnbf8FgcVPID_yYeFrQJEB
// Direct Download Link: Used for the download button
const resumeDownloadLink = "https://drive.google.com/uc?export=download&id=14wqI8NJmdzDnbf8FgcVPID_yYeFrQJEB";
// Preview Link: Used for the embedded viewer (iframe)
const resumePreviewLink = "https://drive.google.com/file/d/14wqI8NJmdzDnbf8FgcVPID_yYeFrQJEB/preview";

function Resume() {
  const [width, setWidth] = useState(1200);

  useEffect(() => {
    setWidth(window.innerWidth);
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      <Container fluid className="resume-section">
        <Particle />
        <Container>
          <Row style={{ justifyContent: "center", position: "relative" }}>
            <Col md={12} className="resume-header text-center">
              <Fade bottom>
                <h1 className="project-heading" style={{ color: "white" }}>
                  My <strong className="purple">Resume </strong>
                </h1>
                <p className="project-subheading">
                  Overview of my professional journey and skills.
                </p>
                <Button
                  variant="primary"
                  href={resumeDownloadLink}
                  target="_blank"
                  className="modern-btn btn-primary mx-auto mb-4"
                  style={{ maxWidth: "250px", position: "relative", zIndex: 2 }}
                >
                  <AiOutlineDownload />
                  &nbsp;Download CV
                </Button>
              </Fade>
            </Col>
          </Row>

          <Row className="resume d-flex justify-content-center">
            <Fade bottom>
              <div className="resume-viewer-container" style={{ position: "relative", zIndex: 2, width: "100%", maxWidth: "900px" }}>
                {/* 
                  Using an iframe for Google Drive preview is the most reliable way to display the PDF 
                  while avoiding CORS issues that typically occur with react-pdf and Google Drive links.
                  This ensures the viewer always shows the latest version from your Google Drive without code changes.
                */}
                <iframe
                  src={resumePreviewLink}
                  width="100%"
                  height={width > 786 ? "800px" : "500px"}
                  style={{ border: "none", borderRadius: "15px" }}
                  title="Resume Preview"
                ></iframe>
              </div>
            </Fade>
          </Row>
        </Container>
      </Container>
    </div>
  );
}

export default Resume;
